export const ImageCasinoBetflik = [
  {
    ch: 'sexy',
    img: '/static/img/game_betflik/casino/SexyGaming.png',
    gameType: 'LOBBY',
    category: 'LIVECASINO',
  },
  {
    ch: 'sa',
    img: '/static/img/game_betflik/casino/sa.png',
    gameType: 'LOBBY',
    category: 'LIVECASINO',
  },
  {
    ch: 'xg',
    img: '/static/img/game_betflik/casino/XTREME.png',
    gameType: 'LOBBY',
    category: 'LIVECASINO',
  },
  {
    ch: 'wm',
    img: '/static/img/game_betflik/casino/WM.png',
    gameType: 'LOBBY',
    category: 'LIVECASINO',
  },
  {
    ch: 'dg',
    img: '/static/img/game_betflik/casino/dream.png',
    gameType: 'LOBBY',
    category: 'LIVECASINO',
  },
  {
    ch: 'r88',
    img: '/static/img/game_betflik/casino/r88.png',
    gameType: 'LOBBY',
    category: 'LIVECASINO',
  },
  {
    ch: 'ag',
    img: '/static/img/game_betflik/casino/ag.png',
    gameType: 'LOBBY',
    category: 'LIVECASINO',
  },
  {
    ch: 'bg',
    img: '/static/img/game_betflik/casino/bg.png',
    gameType: 'LOBBY',
    category: 'LIVECASINO',
  },
  {
    ch: 'eg',
    img: '/static/img/game_betflik/casino/eg.png',
    gameType: 'LOBBY',
    category: 'LIVECASINO',
  },
]
export const ImageSlotBetflik = [
  {
    ch: 'pg',
    img: '/static/img/game_betflik/slot/pg.png',
    gameType: 'LOBBY',
    category: 'EGAMES',
  },
  {
    ch: 'joker',
    img: '/static/img/game_betflik/slot/slotXO.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'jl',
    img: '/static/img/game_betflik/slot/JILI.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'pp',
    img: '/static/img/game_betflik/slot/pragmaticplay.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'rlx',
    img: '/static/img/game_betflik/slot/rlx.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'cq9',
    img: '/static/img/game_betflik/slot/CQ9.png',
    gameType: 'LOBBY',
    category: 'EGAMES',
  },
  {
    ch: 'mg',
    img: '/static/img/game_betflik/slot/microgaming.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'gamatron',
    img: '/static/img/game_betflik/slot/gamatron.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'netent',
    img: '/static/img/game_betflik/slot/NETENT2.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'km',
    img: '/static/img/game_betflik/slot/KINGMAKER.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'sp',
    img: '/static/img/game_betflik/slot/simpleplay.png',
    gameType: 'LOBBY',
    category: 'EGAMES',
  },
  {
    ch: 'ep',
    img: '/static/img/game_betflik/slot/evoplay2.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'kg',
    img: '/static/img/game_betflik/slot/kg.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'ds',
    img: '/static/img/game_betflik/slot/ds.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'aws',
    img: '/static/img/game_betflik/slot/aws.png', //
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'funky',
    img: '/static/img/game_betflik/slot/funky.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'waz',
    img: '/static/img/game_betflik/slot/waz.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'hak',
    img: '/static/img/game_betflik/slot/hak.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: '1x2',
    img: '/static/img/game_betflik/slot/1x2.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'nge',
    img: '/static/img/game_betflik/slot/nge.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'fng',
    img: '/static/img/game_betflik/slot/fng.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'ga',
    img: '/static/img/game_betflik/slot/ga.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'nlc',
    img: '/static/img/game_betflik/slot/nlc.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'mav',
    img: '/static/img/game_betflik/slot/mav.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'tk',
    img: '/static/img/game_betflik/slot/tk.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'ids',
    img: '/static/img/game_betflik/slot/ids.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'qs',
    img: '/static/img/game_betflik/slot/qs.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'red',
    img: '/static/img/game_betflik/slot/red.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'ygg',
    img: '/static/img/game_betflik/slot/ygg.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'kgl',
    img: '/static/img/game_betflik/slot/kgl.png', //
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'hab',
    img: '/static/img/game_betflik/slot/hab.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'bng',
    img: '/static/img/game_betflik/slot/bng.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'bpg',
    img: '/static/img/game_betflik/slot/bpg.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'ps',
    img: '/static/img/game_betflik/slot/ps3.png',
    gameType: 'LOBBY',
    category: 'EGAMES',
  },
  {
    ch: 'swg',
    img: '/static/img/game_betflik/slot/swg.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'fc',
    img: '/static/img/game_betflik/slot/fachailogobf.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'ttg',
    img: '/static/img/game_betflik/slot/toptrend_gaming.png',
    gameType: 'LOBBY',
    category: 'EGAMES',
  },
  {
    ch: 'r88',
    img: '/static/img/game_betflik/slot/r88.png',
    gameType: 'LOBBY',
    category: 'EGAMES',
  },
  {
    ch: 'pug',
    img: '/static/img/game_betflik/slot/pug.png',
    gameType: '*',
    category: 'EGAMES',
  },
  {
    ch: 'png',
    img: '/static/img/game_betflik/slot/png.png',
    gameType: '*',
    category: 'EGAMES',
  },
]
export const ImagePOKERBetflik = [
  {
    ch: 'amb',
    img: '/static/img/game_betflik/card/AMBPOKER.png',
    gameType: 'LOBBY',
    category: 'POKER',
  },
]
export const ImageTRADINGBetflik = []



// WEBPACK FOOTER //
// ./src/config/GameBetflik.js